import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CtaSection({
  title = "Decode your face in seconds.",
  subtitle = "Free, instant, no app download. See your real score and a plan to improve it.",
  to = "/",
  label = "Scan my face free",
}) {
  return (
    <section className="container py-20">
      <div className="radial-fade grain relative overflow-hidden rounded-2xl border border-border bg-card px-6 py-16 text-center md:py-24">
        <h2 className="mx-auto max-w-2xl font-display text-4xl text-balance sm:text-5xl">{title}</h2>
        <p className="mx-auto mt-4 max-w-xl text-muted-foreground">{subtitle}</p>
        <Link
          to={to}
          data-testid="cta-section-btn"
          className="mt-8 inline-flex items-center gap-2 rounded-md bg-primary px-7 py-3 text-sm font-semibold text-primary-foreground transition hover:brightness-110"
        >
          {label} <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
}
